import { render, staticRenderFns } from "./Transactionbill.vue?vue&type=template&id=11828f03"
import script from "./Transactionbill.vue?vue&type=script&lang=js"
export * from "./Transactionbill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports